import { httpClient } from "./common";
import { ResponseData } from "./types";
import { withApiErrorHandling } from "./withApiErrorHandling";

export class FishSpeciesAPI {
  public static readonly BASE_URL = "/fish_species";

  static async getFishSpecies(): Promise<
    ResponseData<{
      id: number;
      name: string;
    }>
  > {
    return withApiErrorHandling(
      () => httpClient.get(`${FishSpeciesAPI.BASE_URL}`, true),
      "Error al obtener las especies de peces"
    );
  }
}
